import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";
import TrueBeliefLegend from "@/components/TrueBeliefLegend";

export default function VraiCroyanceLegende() {
  useSeo({
    title: "Vrai, croyance ou légende ?",
    description: "Un petit jeu pour distinguer ce que l'on sait, ce que l'on croit et ce que l'on raconte autour de l'ésotérisme, du tarot, de l'astrologie et de l'histoire.",
    path: "/vrai-croyance-legende",
  });
  return (
    <div>
      <PageHeader eyebrow="Esprit critique" title="Vrai, croyance ou légende ?" intro="Ce que l'on sait. Ce que l'on croit. Ce que l'on raconte. À vous de deviner — Dorothée IA vous explique ensuite." image={IMG.map} />
      <section className="dl-container py-14 max-w-3xl">
        <TrueBeliefLegend />
      </section>
    </div>
  );
}
